import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import StatusVerifiedIcon from '@atlaskit/icon/core/status-verified';
import type { IconSpacing } from '@atlaskit/icon/types';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

const i18n = defineMessages({
	teamVerifiedLozengeTooltip: {
		id: 'permissions-principals.team-verified-lozenge.tooltip',
		defaultMessage: 'This team is verified because it is controlled by an organization admin.',
		description: 'Tooltip for the verified team lozenge',
	},
	groupVerifiedLozengeTooltip: {
		id: 'permissions-principals.group-verified-lozenge.tooltip',
		defaultMessage: 'This group is verified because it is controlled by an organization admin.',
		description: 'Tooltip for the verified group lozenge',
	},
});

export const VerifiedTeamLozenge = ({
	isTeam = true,
	spacing = 'compact',
}: {
	isTeam?: boolean;
	spacing?: IconSpacing;
}) => {
	const { formatMessage } = useIntl();

	return (
		<Tooltip
			content={
				isTeam
					? formatMessage(i18n.teamVerifiedLozengeTooltip)
					: formatMessage(i18n.groupVerifiedLozengeTooltip)
			}
		>
			<StatusVerifiedIcon
				label="verified team"
				color={token('color.icon.accent.blue')}
				size="small"
				spacing={spacing}
			/>
		</Tooltip>
	);
};
